// Extended tone options
export const TONES = {
  professional: "Clear, business-focused communication",
  casual: "Relaxed, conversational style",
  friendly: "Warm and approachable",
  authoritative: "Expert and commanding",
  humorous: "Light-hearted and entertaining",
  inspirational: "Motivating and uplifting",
  academic: "Scholarly and research-focused",
  storytelling: "Narrative and engaging",
} as const;